import styled from 'styled-components';
import bgimage from '~/assets/asset01.png';

export const Container = styled.div`
  height: 100%;
  background-color: #000;
`;

export const Header = styled.header`
  width: 100%;
  height: 70px;
  padding: 0 20px;
  background: ${props => props.theme.colors.primaryBackground};
  display: flex;
  align-items: center;
  justify-content: center;

  .content-header-policy {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    .logo {
      background-image: url(${props => props.theme.colors.logoVrio});
      background-repeat: no-repeat;
      height: 30px;
      width: 100px;
      text-indent: -5000em;
      display: inline-block;
      background-size: contain;
    }

    .login {
      height: 100%;

      a {
        text-decoration: none;

        button {
          height: 100%;
          padding: 0 20px;
        }

        span {
          color: ${props => props.theme.colors.primaryText};
          font-size: 1.6rem;
        }
      }
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  background: ${props => props.theme.colors.primaryBackground};
  display: flex;
  flex-direction: column;

  .content-header {
    width: 100%;
    height: 200px;

    background-image: url(${bgimage});
    opacity: 0.9;
    background-repeat: no-repeat;
    background-position-y: center;
    background-size: cover;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1,
    h4 {
      color: #fff;
    }

    h1 {
      font-size: 46px;
    }

    h4 {
      font-size: 26px;
      text-align: center;
    }
  }

  .policy-question-fix {
    max-width: 1200px;
    margin: 50px auto 0;
    padding: 0 20px;
    padding-bottom: 40px;

    h3,
    p {
      color: ${props => props.theme.colors.primaryText};
      line-height: 2.2rem;
      margin-bottom: 20px;
    }

    h3 {
      text-align: left;
      margin-top: 50px;
      padding: 15px 0;
      border-bottom: 1px solid #ccc;
      text-transform: uppercase;
    }

    ul {
      padding: 0 30px;
      margin: 30px 0;

      li {
        color: ${props => props.theme.colors.primaryText};
        line-height: 2.2rem;
        margin: 20px 0;
      }
    }
  }

  .faq-question {
    max-width: 1200px;
    margin: 10px auto 50px;
    padding: 0 20px;

    ul {
      padding: 0 30px;

      li {
        color: ${props => props.theme.colors.primaryText};
        line-height: 2.2rem;
        margin: 20px 0;
      }
    }

    .title {
      font-size: 2rem;
    }

    .content {
      font-size: 1.5rem;
    }

    .MuiPaper-root {
      background: none;
      color: ${props => props.theme.colors.primaryText};
      border: 1px solid #929292;
      margin: 20px 0px;

      .MuiIconButton-root {
        color: ${props => props.theme.colors.primaryText};
      }
    }
  }
`;
